import React from "react";

const SettingsSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12.358"
      height="12.909"
      viewBox="0 0 12.358 12.909"
    >
      <path
        fill="#afafaf"
        d="M30.844 16.1l-1.109-.64a5.013 5.013 0 000-1.827L30.844 13a.315.315 0 00.143-.364 6.482 6.482 0 00-1.424-2.462.313.313 0 00-.385-.06l-1.109.64a4.912 4.912 0 00-1.582-.914V8.56a.312.312 0 00-.245-.3 6.543 6.543 0 00-2.842 0 .312.312 0 00-.245.3v1.28a5.067 5.067 0 00-1.582.914l-1.106-.64a.309.309 0 00-.385.06 6.443 6.443 0 00-1.424 2.462.311.311 0 00.142.364l1.109.64a5.013 5.013 0 000 1.827l-1.109.64a.315.315 0 00-.143.364 6.482 6.482 0 001.424 2.462.313.313 0 00.385.06l1.109-.64a4.912 4.912 0 001.582.914v1.28a.312.312 0 00.245.3 6.543 6.543 0 002.842 0 .312.312 0 00.245-.3v-1.28a5.067 5.067 0 001.582-.914l1.109.64a.309.309 0 00.385-.06 6.443 6.443 0 001.424-2.462.321.321 0 00-.145-.371zm-6.022.528a2.082 2.082 0 112.078-2.077 2.085 2.085 0 01-2.079 2.082z"
        transform="translate(-18.644 -8.099)"
      ></path>
    </svg>
  );
};

export default SettingsSVG;
